import React from 'react';
import { Chip, ChipColor } from '../../../../../../Chip';
import { Icon } from '../../../../../../Icon';

interface PropTypes {
  jobName: string;
  departmentName: string;
  applicationsCount: number;
}

export function JobCard(props: PropTypes) {
  return (
    <div className='d-flex justify-content-between align-items-center border rounded-2 border-blue-gray-500 fw-semibold fs-6 mb-3 py-3'>
      <div className='ms-4'>
        <span className='fs-5 me-2'>{props.jobName}</span>
        <Chip color={ChipColor.BlueLight}>{props.departmentName}</Chip>
      </div>
      <div className='me-5'>
        <Icon name='bi-arrow-right' className='me-2' />
        <Chip className='ms-2' color={ChipColor.Orange}>
          {props.applicationsCount} Candidates
        </Chip>
      </div>
    </div>
  );
}
